import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {

  anho: number;

  constructor() { 
    this.anho = new Date().getFullYear();
    
  }

  ngOnInit() {
  }

}
